module.exports = __webpack_public_path__ + "static/media/DonationLayout.f0852d04.png";